import { DrawerProps, Drawer as AntDrawer } from "antd";
import React from "react";
import useQueryParams from "../../hooks/useQueryParams";
export interface IDrawerProps extends DrawerProps {
  matcher: string;
  removeParamsOnClose?: string[];
  removePaddingX?: boolean;
  nextMatcher?: string;
}

const Drawer: React.FC<IDrawerProps> = ({
  children,
  matcher,
  removeParamsOnClose = [],
  removePaddingX,
  nextMatcher,
  ...props
}) => {
  const query = useQueryParams();
  const onClose = () => {
    if(nextMatcher) {
      query.removeMany(matcher, nextMatcher, ...removeParamsOnClose);
    } else {
      query.removeMany(matcher, ...removeParamsOnClose);
    }
  };
  return (
    <AntDrawer
      destroyOnClose
      {...props}
      bodyStyle={removePaddingX ? { paddingRight: 0, paddingLeft: 0 } : {}}
      visible={query.has(matcher)}
      onClose={onClose}
    >
      {children}
    </AntDrawer>
  );
};

export default Drawer;
